// Text catalog for the "Mød en MI Supporter" (Meet a MI Supporter) listing page.
// The supporter cards themselves come from src/data/supporters.ts.

import { type Locale } from "../config";
import { type PageMeta } from "../head";

type ModenmisupporterStrings = {
  meta: PageMeta;
  hero: { eyebrow: string; title: string; body: string; tagline: string };
  team: { heading: string; body: string };
  /** Card link label. {name} is replaced by the supporter's first name. */
  cardLink: string;
  /** Special-case card link label for the Noreen & Thomas joint profile. */
  cardLinkNoreenThomas: string;
};

export const modenmisupporterStrings: Record<Locale, ModenmisupporterStrings> = {
  da: {
    meta: {
      title: "Mød en MI Supporter - MI Support",
      description:
        "Lær vores konsulenter bedre at kende. MI Support består af +45 erfarne konsulenter med vidt forskellige baggrunde.",
      ogImage: "https://www.misupport.dk/wp-content/uploads/Maja-MI-Support2-2-scaled.jpg",
    },
    hero: {
      eyebrow: "Karriere",
      title: "Mød en MI Supporter",
      body: "Som virksomhed er MI Support baseret på vores handlekraftige, ansvarlige og motiverede medarbejdere, der med faglig stolthed arbejder målrettet og engageret for at løse vores kunders udfordringer.",
      tagline: "Lær vores konsulenter bedre at kende her.",
    },
    team: {
      heading: "Team MI Support",
      body: "MI Support består i dag af +45 erfarne konsulenter i alle aldersgrupper og med mange forskellige personlige, faglige og uddannelsesmæssige baggrunde. Lær et par af vores gode kollegaer bedre at kende her.",
    },
    cardLink: "Læs {name}s historie her",
    cardLinkNoreenThomas: "Læs Noreen og Thomas' historie her",
  },

  en: {
    meta: {
      title: "Meet a MI Supporter - MI Support",
      description:
        "Get to know our consultants better. MI Support consists of more than 45 experienced consultants with widely different backgrounds.",
      ogImage: "https://www.misupport.dk/wp-content/uploads/Maja-MI-Support2-2-scaled.jpg",
    },
    hero: {
      eyebrow: "Career",
      title: "Meet a MI Supporter",
      body: "As a company, MI Support is built on our proactive, responsible and motivated employees, who work in a focused and dedicated way with professional pride to solve our customers' challenges.",
      tagline: "Get to know our consultants better here.",
    },
    team: {
      heading: "Team MI Support",
      body: "MI Support today consists of more than 45 experienced consultants of all age groups and with many different personal, professional and educational backgrounds. Get to know a few of our good colleagues better here.",
    },
    cardLink: "Read {name}'s story here",
    cardLinkNoreenThomas: "Read Noreen and Thomas' story here",
  },

  de: {
    meta: {
      title: "Treffen Sie einen MI Supporter - MI Support",
      description:
        "Lernen Sie unsere Berater besser kennen. MI Support besteht aus mehr als 45 erfahrenen Beratern mit ganz unterschiedlichen Hintergründen.",
      ogImage: "https://www.misupport.dk/wp-content/uploads/Maja-MI-Support2-2-scaled.jpg",
    },
    hero: {
      eyebrow: "Karriere",
      title: "Treffen Sie einen MI Supporter",
      body: "Als Unternehmen baut MI Support auf unsere tatkräftigen, verantwortungsbewussten und motivierten Mitarbeiter, die mit fachlichem Stolz zielgerichtet und engagiert daran arbeiten, die Herausforderungen unserer Kunden zu lösen.",
      tagline: "Lernen Sie unsere Berater hier besser kennen.",
    },
    team: {
      heading: "Team MI Support",
      body: "MI Support besteht heute aus mehr als 45 erfahrenen Beratern aller Altersgruppen und mit vielen verschiedenen persönlichen, fachlichen und bildungsbezogenen Hintergründen. Lernen Sie hier einige unserer guten Kollegen besser kennen.",
    },
    cardLink: "Lesen Sie hier die Geschichte von {name}",
    cardLinkNoreenThomas: "Lesen Sie hier die Geschichte von Noreen und Thomas",
  },
};
